/**
 * Design-system typography constants.
 *
 * Each constant composes one semantic typography token (defined in
 * src/styles/theme.css) with the colour / density classes needed
 * for the pattern. Consumers should NEVER add raw font-size,
 * font-weight, leading-*, or tracking-* classes — the ESLint rule
 * `local-rules/no-raw-typography` enforces this on /dashboard.
 *
 * The semantic tokens are:
 *   text-display / text-title-lg / text-title-md / text-title-sm
 *   text-body-lg / text-body / text-body-sm
 *   text-label / text-caption / text-overline
 *   plus compact variants for dense mobile/dashboard list UI
 */

export const DASHBOARD_UTILITY_CARD_TITLE =
  'text-title-sm text-foreground sm:text-title-md';

export const DASHBOARD_KICKER = 'text-overline';

export const DASHBOARD_SECTION_LABEL = 'text-overline text-muted-foreground';

export const DASHBOARD_ROW_TITLE = 'text-title-sm text-foreground';

export const DASHBOARD_COMPACT_SECTION_LABEL =
  'text-label-compact text-muted-foreground';

export const DASHBOARD_COMPACT_ACTION_LABEL =
  'text-overline-compact text-foreground';

export const DASHBOARD_COMPACT_ROW_TITLE =
  'text-title-compact text-foreground';

export const DASHBOARD_COMPACT_ROW_META =
  'text-caption-compact text-muted-foreground';

export const DASHBOARD_COMPACT_ROW_VALUE =
  'stat-value-compact text-foreground';

export const DASHBOARD_COMPACT_STATUS_LABEL =
  'text-caption-compact text-muted-foreground';

export const DASHBOARD_ROW_META_MUTED = 'text-caption text-muted-foreground';

export const DASHBOARD_ROW_META_FOREGROUND = 'text-caption text-foreground';

export const DASHBOARD_CHIP = 'min-h-5 text-overline';

export const DASHBOARD_ACTION_LABEL = 'text-overline';
